import { useEffect, useCallback } from 'react';

export const useScrollToClose = (isMenuOpen, closeCallback) => {
  const handleScroll = useCallback(() => {
    if (isMenuOpen && closeCallback) {
      closeCallback();
    }
  }, [isMenuOpen, closeCallback]);

  useEffect(() => {
    if (isMenuOpen) {
      // Add scroll event listener when menu is open
      window.addEventListener('scroll', handleScroll, { passive: true });
      
      // Also listen for wheel events (mouse wheel)
      window.addEventListener('wheel', handleScroll, { passive: true });
      
      // Listen for touch events (mobile scrolling)
      window.addEventListener('touchmove', handleScroll, { passive: true });
      
      return () => {
        // Clean up event listeners
        window.removeEventListener('scroll', handleScroll);
        window.removeEventListener('wheel', handleScroll);
        window.removeEventListener('touchmove', handleScroll);
      };
    }
  }, [isMenuOpen, handleScroll]);
};
